import { useEffect, useState } from 'react';
import { formatCountdown } from '@/lib/utils';

/**
 * Geri sayım GERÇEK cutoff damgasından üretilir (backend teslimat motoru).
 * Sahte aciliyet yok: süre dolduğunda bileşen kendini kapatır ve çağıran
 * tarafın veriyi tazelemesini ister.
 */
interface CountdownProps {
  /** ISO damgası; null ise aynı gün zaten mümkün değildir. */
  cutoffAt: string | null;
  onExpire?: () => void;
  className?: string;
}

function remainingMinutes(cutoffAt: string): number {
  return Math.max(0, Math.floor((new Date(cutoffAt).getTime() - Date.now()) / 60_000));
}

export function Countdown({ cutoffAt, onExpire, className }: CountdownProps) {
  const [minutes, setMinutes] = useState(() =>
    cutoffAt ? remainingMinutes(cutoffAt) : 0,
  );

  useEffect(() => {
    if (!cutoffAt) {
      return;
    }

    setMinutes(remainingMinutes(cutoffAt));

    // Dakikada bir yeterli: saniye sayacı gereksiz gerilim yaratır.
    const timer = window.setInterval(() => {
      const next = remainingMinutes(cutoffAt);
      setMinutes(next);

      if (next <= 0) {
        window.clearInterval(timer);
        onExpire?.();
      }
    }, 30_000);

    return () => window.clearInterval(timer);
  }, [cutoffAt, onExpire]);

  if (!cutoffAt || minutes <= 0) {
    return null;
  }

  return (
    <span className={className}>
      <time dateTime={cutoffAt}>{formatCountdown(minutes)}</time> kaldı
    </span>
  );
}
